import { LayoutGrid, List, Building2, Star } from "lucide-react";

import { ExploreCategoryFilter, WORK_FILTER_GROUPS, ITEM_FILTER_GROUPS, type ExploreFilterGroup } from "../../components/ExploreCategoryFilter";
import { Tabs, TabsList, TabsTrigger } from "../../components/beui/Tabs";

import { Switch } from "../../components/motion/switch";

import { DiscoverySort } from "../../components/DiscoverySort";

import { hasRating, hasRatingFilter, hasPriceSort } from "./model";
import type { MarketplaceState } from "./useMarketplaceController";
export function createMarketplaceControls(state: MarketplaceState) {
const { lang, t, tabLabel, groupLabel, locked, meta, tab, f, view, loading, loadingMore, loadMoreSentinelRef, fallback, loadError, setRetryKey, layout, setLayout, cityOptions, showFilters, setShowFilters, isWorker, applicationStatuses, applicationStatusesState, set, resetFilters, orgTypes, items, count, activeGroup, intentKeys, presentationIntent, visibleTotal, sectionSelections, filtersActive, activeCount, selectTab, loadMore }=state;
const filterGroups: ExploreFilterGroup[] = tab === "Marketplace" ? ITEM_FILTER_GROUPS : tab === "Companies"
    ? orgTypes.map((type) => ({ value: type.id, label: type.name, Icon: Building2 })) : WORK_FILTER_GROUPS;
  const updateSelections = (values: string[]) => tab === "Marketplace" ? set({ itemTypes: values })
    : tab === "Companies" ? set({ orgTypes: values }) : set({ categories: values, category: "" });
  const sectionFilterControls = (suffix: string) => tab === "Jobseekers" ? <div className="border-t border-line pt-6">
    <label className="mb-2 block text-[13px] font-medium text-mut" htmlFor={`skills-filter-${suffix}`}>{t("discovery.skillsField")}</label>
    <input id={`skills-filter-${suffix}`} className="field" maxLength={120} value={f.category} onChange={(event) => set({ category: event.target.value })} placeholder="e.g. Carpentry, electrical, bookkeeping" />
  </div> : <ExploreCategoryFilter key={`${tab}-${suffix}`} id={`explore-${suffix}`} label={tab === "Marketplace" ? "Item type" : tab === "Companies" ? t("discovery.organizationType") : t("discovery.category")} groups={filterGroups} selected={sectionSelections} onChange={updateSelections} allLabel={lang === "tl" ? "Tingnan lahat" : "Browse all"} selectedLabel={lang === "tl" ? "napili" : "selected"} />;

  const qualityFilterControls = (hasRating(tab) || hasRatingFilter(tab)) && <>
    {hasRatingFilter(tab) && <fieldset className="min-w-0 border-t border-line pt-6">
      <legend className="float-left mb-3 flex w-full items-center gap-2.5 text-[15px] font-semibold text-navy">
        <Star className="h-5 w-5 shrink-0" aria-hidden="true" />{t("discovery.rating")}
      </legend>
      <div className="clear-both grid grid-cols-3 gap-2">
        {([{ label: t("discovery.ratingAll"), value: 0 }, { label: "4★+", value: 4 }, { label: "3★+", value: 3 }]).map(({ label, value }) => (
          <button key={value} type="button" aria-pressed={f.minRating === value} onClick={() => set({ minRating: value })}
            className={`min-h-11 rounded-lg border px-2 py-2.5 text-sm font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-navy focus-visible:ring-offset-2 ${f.minRating === value ? "border-navy bg-navy text-white" : "border-line bg-white text-mut hover:bg-navy-50 hover:text-navy"}`}>
            {label}
          </button>
        ))}
      </div>
    </fieldset>}
    {hasRating(tab) && <div className="border-t border-line pt-6">
      <Switch checked={f.verified} onCheckedChange={(verified) => set({ verified })} label={t("discovery.verifiedOnly")} />
    </div>}
  </>;

  // Reserve toolbar space so changing sort labels cannot move the section tabs.
  const desktopViewControls = (
    <div className="hidden lg:flex w-[278px] items-center justify-end gap-3 shrink-0">
      <DiscoverySort key={tab} className="h-9 w-auto min-w-32 max-w-48 text-xs" value={f.sort} onChange={(sort) => set({ sort })} showRating={hasRating(tab)} showPrice={hasPriceSort(tab)} />
      <Tabs value={layout} onValueChange={(value) => setLayout(value as "grid" | "list")} variant="segment" className="shrink-0">
        <TabsList aria-label="Result layout" className="border border-line">
          <TabsTrigger value="grid" aria-label="Grid view" className="h-9 px-2.5"><LayoutGrid className="h-4 w-4" /></TabsTrigger>
          <TabsTrigger value="list" aria-label="List view" className="h-9 px-2.5"><List className="h-4 w-4" /></TabsTrigger>
        </TabsList>
      </Tabs>
    </div>
  );


return { filterGroups, updateSelections, sectionFilterControls, qualityFilterControls, desktopViewControls };
}
